/** Split retail total across products so line items always sum to the displayed total. */
export function allocateRetailPrices(
  products: ReadonlyArray<{ price: number }>,
  retailTotal: number,
): number[] {
  if (products.length === 0) {
    return [];
  }

  const weightSum = products.reduce((sum, product) => sum + Math.max(product.price, 0), 0);
  if (weightSum <= 0) {
    const even = Math.floor(retailTotal / products.length);
    return products.map((_, index) =>
      index === products.length - 1 ? retailTotal - even * (products.length - 1) : even,
    );
  }

  let used = 0;
  return products.map((product, index) => {
    if (index === products.length - 1) {
      return Math.round(retailTotal - used);
    }
    const share = Math.round((product.price / weightSum) * retailTotal);
    used += share;
    return share;
  });
}
